import React from "react";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { FPLandingPageDesktopHero } from "../FPLandingPageDesktopHero/FPLandingPageDesktopHero";
import { FPLandingPageDesktopWeAre } from "../FPLandingPageDesktopWeAre/FPLandingPageDesktopWeAre";
import { FPLandingPageDesktopExpertise } from "../FPLandingPageDesktopExpertise/FPLandingPageDesktopExpertise";
import { FrontColors } from "../../../../models/FrontColors";
import { Shape } from "../../../BuildingBlocks/Shape";
import { FPLandingPageDesktopHelp } from "../FPLandingPageDesktopHelp/FPLandingPageDesktopHelp";
import { FPLandingPageDesktopGuides } from "../FPLandingPageDesktopGuides/FPLandingPageDesktopGuides";
import { FPFooter } from "../../Simple/FPFooter/FPFooter";
import { Background } from "../../../BuildingBlocks/Background";

type TLandingPageDesktopV2Props = {
    form: TProbateLeadForm;
    onChange: (form: TProbateLeadForm) => void;
    onSubmit: (form: TProbateLeadForm) => void,
};

export const FPLandingPageDesktopV2 = (props: React.PropsWithChildren<TLandingPageDesktopV2Props>): JSX.Element => {

    return (
        <div className={``}>

            {/* HERO */}
            <div style={{
                width: "100%",
                position: "relative",
                zIndex: 1
            }}>
                <FPLandingPageDesktopHero {...props} />
            </div>

            {/* OVERLAY BODY */}
            <div style={{
                position: "absolute",
                top: "1500px",
                width: "100%",
                zIndex: 2,
                boxShadow: "1px 0px 5px 5px rgba(0,0,0,0.2)"
            }}>
                <FPLandingPageDesktopWeAre {...props} />
                <ViewBorder />
                <FPLandingPageDesktopExpertise />
                <FPLandingPageDesktopHelp {...props} />
                <FPLandingPageDesktopGuides />

                <Background
                    color={FrontColors.PROBATE_0}
                    padding="60px 0px"
                >
                    <FPFooter />
                </Background>
            </div>
        </div>
    );
};

const ViewBorder = () => (
    <div style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        backgroundColor: FrontColors.PROBATE_0
        
    }}>
        <Shape
            width="100%"
            maxWidth="1200px"
            height="1px"
            color={FrontColors.NEUTRAL_10_2} 
        />
    </div>
);
